import ErrorBox from '@components/common/ErrorBox';
import { AccordionStepsActionTypes, AftercareActionTypes, UserInfoActionTypes } from '@state/features/common.types';
import Accordion from '@ui/accordion/Accordion';
import AccordionMini from '@ui/accordion/AccordionMini';
import Button from '@ui/button/Button';
import DwFormField from '@ui/formfield/DwFormField';
import analytics from '@utils/analytics';
import api from '@utils/api';
import formutils from '@utils/formutils';
import createDecorator from 'final-form-focus';
import React, { useEffect, useState } from 'react';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import AftercareOrderItem from './AftercareOrderItem';
import { debounce } from '@mui/material/utils';
const focusOnError = createDecorator();
const AftercareStep3 = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [formdef, setFormdef] = useState();
    const [initialValues, setInitialValues] = useState();
    const [errors, setErrors] = React.useState([]);
    const [orderList, setOrderList] = useState();
    const [countriesandcities, setCountriesAndCities] = useState();
    const { user: { isAuthenticated }, } = useSelector((state) => state.userInfo);
    useEffect(() => {
        dispatch({
            type: UserInfoActionTypes.FETCH_USERINFO,
        });
    }, []);
    useEffect(() => {
        api.getBoutiqueCountriesAndCities().then((data) => {
            setCountriesAndCities(data);
        });
    }, []);
    useEffect(() => {
        let val = {};
        api.getForm('aftercare-product', val).then((data) => {
            setInitialValues(val);
            setFormdef(data);
        });
    }, []);
    useEffect(() => {
        if (isAuthenticated) {
            api.getOrders().then((data) => setOrderList(data));
        }
    }, [isAuthenticated]);
    const validate = async (values) => {
        return await formutils.validateForm(values, formdef, 'aftercare-product');
    };
    const checkAccordionOnClick = async (values) => {
        var _a;
        if (values.purchased == 'Moncler.com' && !values.garmentName) {
            // https://jira.industries-group.com/browse/OE-7955
            // the form doesn't get re-rendered here, this is the only method to force show field with errors
            (_a = document.getElementsByClassName('accordion-mini__header')) === null || _a === void 0 ? void 0 : _a[0].setAttribute('aria-expanded', 'true');
        }
    };
    const onSubmit = async (values) => {
        console.warn('onSubmit');
        setErrors([]);
        let errors = await validate(values);
        if (errors && Object.keys(errors).length > 0) {
            return errors;
        }
        return api
            .aftercareStep3(values, formdef)
            .then((data) => {
            if (data.success) {
                dispatch({
                    type: AftercareActionTypes.UPDATE_AFTERCARE,
                    payload: values,
                });
                dispatch({
                    type: AccordionStepsActionTypes.NAVIGATE_STEP,
                    payload: 'images',
                });
            }
            if (data.error && data.error.length > 0) {
                setErrors(data.error);
            }
            if (!formutils.checkValidationAfterSubmit(data, errors)) {
                return errors;
            }
            analytics.aftercareThree();
        })
            .catch((e) => setErrors([e]));
    };
    const variant = (type, item) => {
        var _a, _b, _c, _d;
        if (type === 'colour') {
            return ((_b = (_a = item === null || item === void 0 ? void 0 : item.variationAttributes) === null || _a === void 0 ? void 0 : _a.find((v) => v.id == 'color')) === null || _b === void 0 ? void 0 : _b.displayValue) || (item === null || item === void 0 ? void 0 : item.localizedColor);
        }
        if (type === 'size') {
            return ((_d = (_c = item === null || item === void 0 ? void 0 : item.variationAttributes) === null || _c === void 0 ? void 0 : _c.find((v) => v.id == 'size')) === null || _d === void 0 ? void 0 : _d.displayValue) || (item === null || item === void 0 ? void 0 : item.localizedSize);
        }
    };
    const setProductFromOrder = (item, values, mutator, orderNo) => {
        if (orderNo) {
            values.orderNo = orderNo;
        }
        let update = {
            garmentName: item.productName,
            productCode: item.id,
            size: variant('size', item),
            colour: variant('colour', item),
        };
        mutator(update);
    };
    const handleGoBack = () => {
        dispatch({
            type: AccordionStepsActionTypes.NAVIGATE_STEP,
            payload: 'service',
        });
        analytics.aftercareBackEdit('product identification', 'back');
    };
    const renderForm = (values) => {
        var _a;
        return (React.createElement(React.Fragment, null,
            values.purchased === 'Other Websites' && (React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-12" },
                    React.createElement(DwFormField, { def: formdef, name: "websiteName", requiredLabel: true })))),
            values.purchased === 'Other Stores' && (React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-12" },
                    React.createElement(DwFormField, { def: formdef, name: "storeNameLocation", requiredLabel: true })))),
            values.purchased === 'Moncler Boutique' && countriesandcities && (React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-6" },
                    React.createElement(DwFormField, { def: formdef, type: "select", options: [{ value: '', label: '' }].concat(countriesandcities === null || countriesandcities === void 0 ? void 0 : countriesandcities.map((c) => {
                            return { value: c.name, label: c.name };
                        })), name: "storeCountry", requiredLabel: true })),
                React.createElement("div", { className: "col-md-6" },
                    React.createElement(DwFormField, { def: formdef, type: "select", options: values.storeCountry
                            ? [{ value: '', label: '' }].concat((_a = countriesandcities === null || countriesandcities === void 0 ? void 0 : countriesandcities.find((c) => c.name == values.storeCountry)) === null || _a === void 0 ? void 0 : _a.cities.map((c) => {
                                return { value: c, label: c };
                            }))
                            : [], name: "storeCity", requiredLabel: true })))),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-12" },
                    React.createElement(DwFormField, { def: formdef, name: "garmentName" }))),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-12" },
                    React.createElement(DwFormField, { def: formdef, name: "productCode" }))),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-4" },
                    React.createElement(DwFormField, { def: formdef, name: "size" })),
                React.createElement("div", { className: "col-8" },
                    React.createElement(DwFormField, { def: formdef, name: "colour" })))));
    };
    if (!formdef) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "aftercare__form" },
        React.createElement(Form, { onSubmit: onSubmit, validate: debounce(validate, 300), decorators: [focusOnError], initialValues: initialValues, mutators: { global: formutils.globalMutator }, render: ({ handleSubmit, form, submitting, pristine, values }) => (React.createElement("form", { onSubmit: handleSubmit },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-12" },
                        React.createElement(DwFormField, { def: formdef, name: "purchased", type: "select" }))),
                values.purchased &&
                    (values.purchased === 'Moncler.com' && (orderList === null || orderList === void 0 ? void 0 : orderList.length) > 0 ? (React.createElement(React.Fragment, null,
                        React.createElement("p", { className: "aftercare__form__step-description" }, t('aftercare.productfrompreviousorder')),
                        React.createElement("div", { className: "line" }),
                        React.createElement(Accordion, null, orderList.map((order, i) => (React.createElement(AftercareOrderItem, { key: i, order: order, index: i, selectItem: (item) => setProductFromOrder(item, values, form.mutators.global, order.orderNumber) })))),
                        React.createElement("div", { className: "aftercare__form__button-link" },
                            React.createElement(AccordionMini, { id: "anotherOrder", title: t('aftercare.lookingforanotherorder') }, renderForm(values))))) : (renderForm(values))),
                React.createElement(ErrorBox, { errors: errors }),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-sm-6 d-none d-sm-flex " },
                        React.createElement(Button, { type: "button", cls: ['button--tertiary', 'button--arrow-left'], onClick: handleGoBack }, t('button.back'))),
                    React.createElement("div", { className: "col-sm-6" },
                        React.createElement(Button, { type: "submit", disabled: submitting, cls: ['button--primary'], onClick: () => checkAccordionOnClick(values) }, t('aftercare.proceedtoimages')))))) })));
};
export default AftercareStep3;
